module.exports = __webpack_public_path__ + "img/car-34.f5cfba07.jpg";